import edgeMessages from './messages/edgeMessages';
import DisplayImageStraightEdge from './images/edges/shapes/EdgeShape_1_str.png';
import DisplayImageChamferedEdge from './images/edges/shapes/EdgeShape_2_chmf.png';
import DisplayImageRoundEdge from './images/edges/shapes/EdgeShape_3_rnd.png';
import DisplayImageHalfRoundEdge from './images/edges/shapes/EdgeShape_4_hlf_rnd.png';
import DisplayImageBevelEdge from './images/edges/shapes/EdgeShape_5_bvl.png';
import DisplayImageAntiDripEdge from './images/edges/shapes/EdgeShape_6_anti-drop.png';
import DisplayImageLargeStraightEdge from './images/edges/shapes/EdgeShape_1_str_500x500.png';
import DisplayImageLargeChamferedEdge from './images/edges/shapes/EdgeShape_2_chmf_500x500.png';
import DisplayImageLargeRoundEdge from './images/edges/shapes/EdgeShape_3_rnd_500x500.png';
import DisplayImageLargeHalfRoundEdge from './images/edges/shapes/EdgeShape_4_hlf_rnd_500x500.png';
import DisplayImageLargeBevelEdge from './images/edges/shapes/EdgeShape_5_bvl_500x500.png';
import DisplayImageLargeAntiDripEdge from './images/edges/shapes/EdgeShape_6_anti-drop_500x500.png';
import PictoStraightEdge from './images/edges/shapes/picto/picto_EdgeShape_1_str.png';
import PictoChamferedEdge from './images/edges/shapes/picto/picto_EdgeShape_2_chmf.png';
import PictoRoundEdge from './images/edges/shapes/picto/picto_EdgeShape_3_rnd.png';
import PictoHalfRoundEdge from './images/edges/shapes/picto/picto_EdgeShape_4_hlf_rnd.png';
import PictoBevelEdge from './images/edges/shapes/picto/picto_EdgeShape_5_bvl.png';
import PictoAntiDripEdge from './images/edges/shapes/picto/picto_EdgeShape_6_anti-drop.png';

export const edgeShapes = {
  straight: {
    displayImage: DisplayImageStraightEdge,
    displayImageLarge: DisplayImageLargeStraightEdge,
    pictogramImage: PictoStraightEdge,
  },
  chamfered: {
    displayImage: DisplayImageChamferedEdge,
    displayImageLarge: DisplayImageLargeChamferedEdge,
    pictogramImage: PictoChamferedEdge,
  },
  round: {
    displayImage: DisplayImageRoundEdge,
    displayImageLarge: DisplayImageLargeRoundEdge,
    pictogramImage: PictoRoundEdge,
  },
  'half-round': {
    displayImage: DisplayImageHalfRoundEdge,
    displayImageLarge: DisplayImageLargeHalfRoundEdge,
    pictogramImage: PictoHalfRoundEdge,
  },
  bevel: {
    displayImage: DisplayImageBevelEdge,
    displayImageLarge: DisplayImageLargeBevelEdge,
    pictogramImage: PictoBevelEdge,
  },
  'anti-drip': {
    displayImage: DisplayImageAntiDripEdge,
    displayImageLarge: DisplayImageLargeAntiDripEdge,
    pictogramImage: PictoAntiDripEdge,
  },
};

function processCondition(cond) {
  if (cond.thickness) {
    return ({
      thickness
    }) => thickness === cond.thickness;
  } else {
    // TODO: show error in UI
    console.error('Unknown condition', cond); // eslint-disable-line no-console
    return () => false;
  }
}

const getEdgeImage = (expression, thicknessOption, imageName) => {
  const exprThicknesses = expression.get('thicknesses');
  const imgSrc = (exprThicknesses && thicknessOption && exprThicknesses.find((thickI) => thickI.get('thickness') >= thicknessOption.get('min') && thickI.get('thickness') <= thicknessOption.get('max'))) || exprThicknesses.get(0);
  return imgSrc.get(imageName);
};

function getDisplayImageFn(id) {
  switch (id) {
    case 'same-color':
      return (expression, thicknessOption) => getEdgeImage(expression, thicknessOption, 'cornerImage');
    case 'aluminium':
      return (expression, thicknessOption) => getEdgeImage(expression, thicknessOption, 'aluminiumEdgeImage');
    default:
      return () => '';
  }
}

function getDisplayImageLargeFn(id) {
  switch (id) {
    case 'same-color':
      return (expression, thicknessOption) => getEdgeImage(expression, thicknessOption, 'cornerImageLarge');
    case 'aluminium':
      return (expression, thicknessOption) => getEdgeImage(expression, thicknessOption, 'aluminiumEdgeImageLarge');
    default:
      return () => '';
  }
}

function contains(a, obj) {
  for (var i = 0; i < a.length; i++) {
    if (a[i].value === obj) {
      return true;
    }
  }
  return false;
}

export function generateEdgeOptions({
  edges = []
}) {
  return edges.map((id) => {
    let edgeShape = edgeShapes[id] || {};
    if (id === 'same-color') {
      edgeShape = edgeShapes['straight'] || {};
    }
    return ({
      ...edgeShape,
      id,
      displayName: edgeMessages[id] || {
        id: `edges.${id}`
      },
      displayImageFn: getDisplayImageFn(id),
      displayImageLargeFn: getDisplayImageLargeFn(id),
      padImage: id !== 'same-color',
      edgeShape: id !== 'same-color' && !!edgeShapes[id],
    });
  });
}

export function generateEdgeOptionsWithFiltering(businessRules, itemLookup) {
  if (businessRules.showOnlyAvailableEdges == undefined || !businessRules.showOnlyAvailableEdges) {
    return generateEdgeOptions(businessRules);
  }

  const existingEdges = [];
  businessRules.materials.forEach(x => {
    // Check if edges exist for the material, if not continue to the next material
    if (!x.edges) return;
  
    x.edges.forEach(e => {
      if ((e.frontEdge || e.visibleEdge) && (itemLookup(e.frontEdge) || itemLookup(e.visibleEdge))) {
        existingEdges.push(e);
      }
    });
  });
  
  return businessRules.edges.map((id) => {
    for (const e of existingEdges) {
      if (e != undefined && contains(existingEdges, (id))) {
        let edgeShape = edgeShapes[id] || {};
        if (id === 'same-color') {
          edgeShape = edgeShapes['straight'] || {};
        }
        return ({
          ...edgeShape,
          id,
          displayName: edgeMessages[id] || {
            id: `edges.${id}`
          },
          displayImageFn: getDisplayImageFn(id),
          displayImageLargeFn: getDisplayImageLargeFn(id),
          padImage: id !== 'same-color',
          edgeShape: id !== 'same-color' && !!edgeShapes[id],
        });
      }
      console.log('Excluding edge:', id, 'due to missing supporting worktops.');
    }
  }).filter(function (n) {
    return n != undefined
  });
}



export function generateEdges(materialId, edges, allowedEdges = [], itemLookup) {
  if(edges.length === 0){
    return "noEdgeIncluded";
  }
  return edges.filter((edge) => {
    if (!allowedEdges.includes(edge.value)) {
      // eslint-disable-next-line no-console
      console.error('Excluding unknown edge:', edge.value, 'defined in material', materialId);
      return false;
    }

    if (edge.frontEdge && !itemLookup(edge.frontEdge)) {
      // eslint-disable-next-line no-console
      console.error('Excluding edge:', edge.value, 'due to missing item for front edge', edge.frontEdge.ItemNo);
      return false;
    }

    if (edge.visibleEdge && !itemLookup(edge.visibleEdge)) {
      // eslint-disable-next-line no-console
      console.error('Excluding edge:', edge.value, 'due to missing item for visible edge', edge.visibleEdge.ItemNo);
      return false;
    }

    return true;
  }).map((edge) => ({
    value: edge.value,
    frontEdge: itemLookup(edge.frontEdge),
    visibleEdge: itemLookup(edge.visibleEdge),
    conditions: (edge.conditions || []).map(processCondition),
    ignoreExpression: (edge.ignoreExpressions || []).map((ignoreExpression) => {
      return itemLookup(ignoreExpression);
    }),
    allowedThicknesses: (edge.allowedThicknesses || false),
    frontEdgeIncludedInPrice: (edge.frontEdgeIncludedInPrice || false),
  }));
}
